module.exports = __webpack_public_path__ + "static/media/badge_support_3.0622bbf0.png";


//////////////////
// WEBPACK FOOTER
// ./src/icons/badges/badge_support_3.png
// module id = 521
// module chunks = 0